export default {
	GET_ENVELOPE_LIST: (state, data) => {
		state.envelopeList = data;
	},
	GET_ENVELOPE_INFO: (state, data) => {
		state.envelopeInfo = data;
	},
	GET_ENVELOPE_SHOP_LIST: (state, data) => {
		state.envelopeShopList = data;
	},
	ENVELOPE_STATICS_INFO: (state, data) => {
		state.envelopeStaticsInfo = data;
	},
	GET_ENVELOPE_RECORD_LIST: (state, data) => {
		state.envelopeRecordList = data;
	},
	GET_SHOP_ENVELOPE_RECORD: (state, data) => {
		state.shopEnvelopeRecordList = data;
	},
}


// WEBPACK FOOTER //
// ./src/store/mp/marketing/envelope/mutations.js